import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { toast } from "sonner";

/**
 * Hook to mark receipts as uploaded after files have been uploaded to storage.
 */
export function useMarkReceiptsUploaded() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.expense.markReceiptsUploaded.mutationOptions(),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: trpc.expense.getMyExpenses.queryKey(),
        }),
        queryClient.invalidateQueries({
          queryKey: trpc.expense.getPendingExpensesForOrg.queryKey(),
        }),
      ]);
      toast.success("Expense submitted successfully");
    },
  });

  return mutation;
}
